"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoStyles = exports.CloseIconStyles = exports.CloseButtonStyles = void 0;
const CloseButtonStyles = () => {
    return {
      height: "3.4rem",
      margin: "0",
      padding: "0",
      minWidth: "3.4rem",
      width: "3.4rem"
    };
  },
  CloseIconStyles = theme => {
    return {
      color: theme.mixins.navigation.mobile.closeIconColor,
      height: "3.4rem",
      width: "3.4rem"
    };
  },
  LogoStyles = theme => {
    return {
      alignItems: "center",
      backgroundColor: theme.mixins.navigation.mobile.logoBackgroundColor,
      boxShadow: "unset",
      borderRadius: "0",
      display: "flex",
      justifyContent: "space-between",
      padding: "2rem 2.6rem !important",
      width: "100%",
      ".mobile-logo__image": {
        height: "5.8rem",
        width: "17rem"
      }
    };
  };
exports.LogoStyles = LogoStyles;
exports.CloseIconStyles = CloseIconStyles;
exports.CloseButtonStyles = CloseButtonStyles;